<div class="left-wrapper">
  <div class="tracker-checkbox" [class.checked]="tracker.checked" (click)="onToggle()">
    <i class="icon-btn checkbox-icon" i-bs name="check" width="17" height="17"></i>
  </div>
  <span class="tracker-name">{{ tracker.name }}</span>
</div>
<div #bContainer class="right-wrapper" [class.protected]="tracker.protected || isNewPatientGroup">
  <span class="tracker-description">{{ tracker.description }}</span>
  <div #dropdown="bs-dropdown"
       *ngIf="!tracker.protected"
       (click)="$event.stopPropagation()"
       container="body"
       class="dropdown mr5px"
       dropdown>
    <i class="icon-btn more-action-button" i-bs name="three-dots" width="24" height="24" dropdownToggle></i>
    <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
    <ul #bAct
        *dropdownMenu
        [id]="tracker.name"
        class="dropdown-menu dropdown-menu-right"
        [class.dropstart]="!offsetDropdown(bContainer, bAct, 300)"
        [class.dropend]="offsetDropdown(bContainer, bAct,300)"
        role="menu">
      <li role="menuitem">
        <span class="dropdown-item" id="action-edit" (click)="dropdown.hide(); editAction?.emit()">
          Éditer le tracker
        </span>
      </li>
      <li role="menuitem" *ngIf="!tracker.protected">
        <span class="dropdown-item" id="action-delete" (click)="dropdown.hide(); deleteAction?.emit()">
          Supprimer le tracker
        </span>
      </li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem"><span id="action-cancel" class="dropdown-item action" (click)="dropdown.hide()">Annuler</span>
      </li>
    </ul>
  </div>
</div>
<div class="handler-button">
  <img src="/assets/images/drag-drop-indicator.svg" width="10px" height="16px" alt="⋮" />
</div>
